import {VGMap} from "../../../../../modules/index.esm";
import {findAll, findID} from "../../../../../modules/vegas/js/util";
import YandexMap from "./ymap";

function onReady() {
	let maps = findAll('[data-vg-map]');

	if (maps.length) {
		[...maps].map(function (map) {
			new YandexMap().include(function (){
				VGMap.init(map);
			});
		});
	}

	// локация пользователя
	if (('location' in App) && App.location) {
		VGMap.Location.init(function (data) {
			VGMapLocation.set(data)
		});
	}

	// Кастомная карта
	const customMap = findID('yaMapContacts');
	if (customMap) {
		new YandexMap().include(function (){
			VGMap.init('yaMapContacts', {
				callback: {
					afterInitMap: function (map, params, _this) {
						yaMapContacts.run(map, params, _this);
					}
				}
			});
		});
	}
}

document.addEventListener("DOMContentLoaded", onReady);
onTurboRender(onReady);

const yaMapContacts = {
	run: function (map, params, self) {
		let markers = self.PlaceMark.set(map, params);

		let $pointList = document.querySelectorAll('[data-vg-toggle="map"]');
		if ($pointList.length) {
			$pointList.forEach(function (point, i) {
				point.onclick = function () {
					document.getElementById("yaMapContacts").scrollIntoView();

					map.setCenter([point.dataset.lat, point.dataset.lon], 16);
					self.Map.offset(map, params);

					markers.forEach(function (placemark, n) {
						if (i === n) {
							[...markers].map((marker) => {
								marker.options.set('iconImageHref', '/assets/_frontend/images/icons/marker-disabled.svg');
							})

							placemark.options.set('iconImageHref', '/assets/_frontend/images/icons/marker.svg');
						}
					});

					return false;
				}
			});
		}
	},
}

const VGMapLocation = {
	city: App.city || "Москва",
	coordinates: null,
	cities: App.cities || [],
	containers: [],
	isConfirmed: false,

	set: function (data) {
		let _this = this;

		_this = Object.assign({}, _this, data);
		_this.city = _this.geoObjects.get(0).getLocalities().join('');
		_this.coordinates = _this.geoObjects.get(0).geometry.getCoordinates();

		_this.containers.push(document.querySelectorAll('[data-location-city]') || null)
		document.body.setAttribute('data-location-confirm', 'false');

		let $containers = _this.containers,
			isConfirmed = document.body.dataset.locationConfirm || null;

		_this.isConfirmed = isConfirmed !== 'false';

		for (let containers of $containers) {
			for (const $container of containers) {
				$container.innerText = _this.city;

				if (!this.isConfirmed) {
					let spanElement = document.createElement('span');
					spanElement.classList.add('location-confirmed');
					spanElement.innerText = '?';

					$container.append(spanElement);
				}
			}
		}
	}
}
